import {
    graphicEvents,
    HOVER_SEAT,
    ON_CHANGE_TRANSLATE, ON_CHANGE_ZOOM, SET_PICKER_MODE,
    SET_PICKER_SELECTION,
    UNHOVER_SEAT
} from "../../GraphicEvents";
import { EntityService } from "../../entity/EntityService";
import { GraphicItemService } from "../../entity/row/GraphicItemService";
import { graphic } from "../../Graphic";
import { Row } from "../../entity/row/Row";
import { Pit } from "../../entity/pit/Pit";
import { Entity } from "../../entity/Entity";

export class Picker {

    static MODE_BOOKING = 'booking';
    static MODE_STATUS = 'status';
    static MODE_CATEGORIES = 'categories';

    static SELECTION_ROW = 'selection_row';
    static SELECTION_SEAT = 'selection_seat';

    constructor({
        type,
        events,
        mode = Picker.MODE_BOOKING,
        itemsSelected = []
    }) {
        this.mode = mode;
        this.looper = null;
        this.blinkers = {};
        this.type = type;
        this.events = events;
        this.itemsSelected = itemsSelected;
        this.selectionMode = Picker.SELECTION_SEAT;
        this.actionsStack = [];
        if (this.mode === Picker.MODE_BOOKING) this.startBlinkItems();

        graphicEvents.on('UNSELECT_ALL', () => this.unselectAll());
        graphicEvents.on(ON_CHANGE_TRANSLATE, () => this.actionsStack = []);
        graphicEvents.on(ON_CHANGE_ZOOM, () => this.actionsStack = []);

        graphic.entityManager.forEach(this.type, entity => {
            if (entity.isEnable) entity.graphicItems.forEach((graphicItem, index) => {
                if (!entity.isDisabledGraphicItem(index) || (this.mode === Picker.MODE_STATUS && graphicItem.status === Entity.GRAPHIC_STATE_DISABLED)) {
                    this.initGraphicPicker(entity, graphicItem, index);
                }
            })
        });

        graphicEvents.on(SET_PICKER_SELECTION, value => {
            this.selectionMode = value;
        });

        graphicEvents.on(SET_PICKER_MODE, value => {
            this.mode = value;
        });

        graphicEvents.on('SEE_PLACE', ({ seatReference, pitId }) => {
            let find = null;
            if (seatReference) find = GraphicItemService.findBySeatReference(seatReference);
            if (pitId) find = GraphicItemService.findByPitId(pitId);
            if (find) {
                const [entity, graphicItem, index] = find;
                GraphicItemService.cibling(graphicItem);
            }
        });

        graphicEvents.on(this.events.on.select, ({ seatReference, pitId }) => {
            let find = null;
            if (seatReference) find = GraphicItemService.findBySeatReference(seatReference);
            if (pitId) find = GraphicItemService.findByPitId(pitId);
            if (find) {
                const [entity, _, index] = find;
                if (entity instanceof Pit) entity.addTicket();
                if (entity instanceof Pit && entity.countTicket > 1) return;
                this.addSelected(entity.graphicItems[index]);
            }
        });

        graphicEvents.on(this.events.on.unselect, ({ seatReference, pitId }) => {
            console.log('ON UNSELECT')
            let find = null;
            if (seatReference) find = GraphicItemService.findBySeatReference(seatReference);
            if (pitId) find = GraphicItemService.findByPitId(pitId);
            if (find) {
                const [entity, _, index] = find;
                if (entity instanceof Pit) entity.removeTicket();
                if (entity instanceof Pit && entity.countTicket > 0) return;
                this.removeSelected(entity.graphicItems[index]);
            }
        });
    }

    destroy() {
        this.stopBlinkItems();
        graphic.entityManager.forEach(this.type, entity => {
            if (entity.isEnable) entity.graphicItems.forEach((graphicItem, index) => {
                if (entity.graphicItemsEvents[index]) {
                    this.disableGraphicPicker(entity, graphicItem, index);
                }
            })
        });

        graphicEvents.removeAll(this.events.on.select);
        graphicEvents.removeAll(this.events.on.unselect);
    }

    startBlinkItems() {
        const duration = 2000;
        this.looper = setInterval(() => {
            this.itemsSelected.forEach((item, index) => {
                EntityService.outGraphicItem(item, false);
                this.blinkers[index] = {
                    item,
                    timeOut: setTimeout(() => EntityService.overGraphicItem(item, false), duration / 4)
                };
            });
        }, duration);
    }

    stopBlinkItems() {
        Object.values(this.blinkers).forEach(blinker => clearTimeout(blinker.timeOut));
        clearInterval(this.looper);
        this.looper = null;
        this.blinkers = [];
    }

    removeBlinker(graphicItem) {
        Object.values(this.blinkers).forEach(blinker => {
            if (blinker.item === graphicItem) {
                clearTimeout(blinker.timeOut);
            }
        });
    }

    isSelected(item) {
        return this.itemsSelected.includes(item)
    }

    addSelected(graphicItem) {
        const indexSelected = this.itemsSelected.indexOf(graphicItem);
        if (indexSelected === -1) {
            switch (this.mode) {
                case Picker.MODE_STATUS: {
                    EntityService.invalidateGraphicItem(graphicItem, false);
                    break;
                }
                case Picker.MODE_BOOKING:
                default: {
                    EntityService.overGraphicItem(graphicItem, false);
                    break;
                }
            }
            this.itemsSelected.push(graphicItem);
        }
    }

    removeSelected(graphicItem) {
        const indexSelected = this.itemsSelected.indexOf(graphicItem);
        if (indexSelected !== -1) {
            this.removeBlinker(graphicItem);
            this.itemsSelected.splice(indexSelected, 1);

            switch (this.mode) {
                case Picker.MODE_STATUS: {
                    EntityService.validateGraphicItem(graphicItem, false);
                    break;
                }
                case Picker.MODE_BOOKING:
                default: {
                    EntityService.outGraphicItem(graphicItem);
                    break;
                }
            }
        }
    }

    unselectAll() {
        this.stopBlinkItems();
        this.itemsSelected.forEach(item => EntityService.outGraphicItem(item));
        this.itemsSelected = [];
        this.startBlinkItems();
    }

    initGraphicPicker(entity, graphicItem, index) {
        entity.graphicItemsEvents[index] = {
            onGraphicItemOver: this.onGraphicItemOver.bind(this, entity, graphicItem, index, false),
            onGraphicItemOut: this.onGraphicItemOut.bind(this, entity, graphicItem, index, false),
            onGraphicItemPointerDown: this.onGraphicItemPointerDown.bind(this, entity, graphicItem, index, false, false),
            onGraphicItemPointerUp: this.onGraphicItemPointerUp.bind(this),
        };
        graphicItem.interactive = true;
        graphicItem.on('pointerover', entity.graphicItemsEvents[index].onGraphicItemOver);
        graphicItem.on('pointerout', entity.graphicItemsEvents[index].onGraphicItemOut);
        graphicItem.on('pointerdown', entity.graphicItemsEvents[index].onGraphicItemPointerDown);
        graphicItem.on('pointerup', entity.graphicItemsEvents[index].onGraphicItemPointerUp);
    }

    disableGraphicPicker(entity, graphicItem, index) {
        graphicItem.off('pointerover', entity.graphicItemsEvents[index].onGraphicItemOver);
        graphicItem.off('pointerout', entity.graphicItemsEvents[index].onGraphicItemOut);
        graphicItem.off('pointerdown', entity.graphicItemsEvents[index].onGraphicItemPointerDown);
        graphicItem.off('pointerup', entity.graphicItemsEvents[index].onGraphicItemPointerUp);
        graphicItem.interactive = false;
        entity.graphicItemsEvents[index] = null;
        this.removeSelected(entity.graphicItems[index]);
    }

    onGraphicItemOver(entity, graphicItem, index, callSelf = false) {
        if (!callSelf && this.selectionMode === Picker.SELECTION_ROW) {
            entity.graphicItems.forEach((item, index) => {
                if (this.mode === Picker.MODE_STATUS && item.status === Entity.GRAPHIC_STATE_BOOKED) return;
                if (this.mode === Picker.MODE_BOOKING && item.status === Entity.GRAPHIC_STATE_DISABLED) return;

                this.onGraphicItemOver(entity, item, index, true);
            });
            return;
        }

        graphic.app.stage.cursor = 'pointer';
        if (!this.isSelected(graphicItem) || this.mode === Picker.MODE_STATUS || this.mode === Picker.MODE_CATEGORIES) {
            graphicEvents.trigger(HOVER_SEAT, { row: entity, index });
            EntityService.overGraphicItem(entity.graphicItems[index]);
        }
    }

    onGraphicItemOut(entity, graphicItem, index, callSelf = false) {
        if (!callSelf && this.selectionMode === Picker.SELECTION_ROW) {
            entity.graphicItems.forEach((item, index) => {
                if (this.mode === Picker.MODE_STATUS && item.status === Entity.GRAPHIC_STATE_BOOKED) return;
                if (this.mode === Picker.MODE_BOOKING && item.status === Entity.GRAPHIC_STATE_DISABLED) return;

                this.onGraphicItemOut(entity, item, index, true);
            });
            return;
        }

        graphic.app.stage.cursor = 'default';
        if (!this.isSelected(graphicItem) || this.mode === Picker.MODE_STATUS || this.mode === Picker.MODE_CATEGORIES) {
            graphicEvents.trigger(UNHOVER_SEAT, { row: entity, index });
            EntityService.outGraphicItem(entity.graphicItems[index]);
        }
    }

    onGraphicItemPointerUp() {
        this.actionsStack.forEach(action => action());
        this.actionsStack = [];
    }

    onGraphicItemPointerDown(entity, graphicItem, index, callSelf = false) {
        if (entity.isEnable === false) return;

        if (!callSelf && this.selectionMode === Picker.SELECTION_ROW) {

            const items = entity.graphicItems.filter(item => (
                (this.mode === Picker.MODE_STATUS && item.status !== Entity.GRAPHIC_STATE_BOOKED) ||
                (this.mode === Picker.MODE_BOOKING && item.status !== Entity.GRAPHIC_STATE_DISABLED)
            ));

            const same = items.every(item => {
                if (this.mode === Picker.MODE_STATUS && item.status === Entity.GRAPHIC_STATE_BOOKED) {
                    return true;
                }
                return item.status === items[0].status;
            });

            items.forEach(item => {
                if (this.mode === Picker.MODE_STATUS && item.status === Entity.GRAPHIC_STATE_BOOKED) return;
                if (this.mode === Picker.MODE_BOOKING && item.status === Entity.GRAPHIC_STATE_DISABLED) return;

                if (!same && item.status !== items[0].status) {
                    this.onGraphicItemPointerDown(entity, item, entity.graphicItems.indexOf(item), true);
                } else if (same) {
                    this.onGraphicItemPointerDown(entity, item, entity.graphicItems.indexOf(item), true);
                }
            });

            return;
        }

        this.actionsStack.push(() => {
            graphicEvents.trigger(
                this.isSelected(graphicItem)
                    ? this.events.trigger.unselect
                    : this.events.trigger.select,
                {
                    entity,
                    seatReference: entity instanceof Row ? Row.getSeatReference(entity, index) : null,
                    pitId: entity instanceof Pit ? entity.id : null,
                    categoryId: entity instanceof Row ? entity.getGraphicItemCategory(index) : entity.category.id
                }
            );

            EntityService.overGraphicItem(graphicItem);

            if (entity instanceof Pit) return;

            if (this.isSelected(graphicItem)) {
                this.removeSelected(graphicItem)
            } else {
                this.addSelected(graphicItem)
            }
        });
    }
}